import { CollectionsItem } from '../CollectionsList/types'

export const getListIdToSendMessage = (list: CollectionsItem) => {
  if (list.type === 'custom') {
    return list.id
  }

  return list.id.split('-')[0]
}
